module.exports = __webpack_public_path__ + "static/img/musicScore_cate.be61042.be61042d.jpg";